
/**
 * Helper function to find values across multiple potential column names
 * Used by both product and category parsers
 */
export const getColumnValue = (row: Record<string, any>, possibleNames: string[]): any => {
  // Check direct property access first
  for (const name of possibleNames) {
    if (row[name] !== undefined && row[name] !== null) {
      return row[name];
    }
  }
  
  // Then check case-insensitive match on all keys with trimming to handle spacing issues
  for (const key of Object.keys(row)) {
    const trimmedKey = key.trim().toLowerCase();
    if (possibleNames.some(name => trimmedKey === name.trim().toLowerCase())) {
      return row[key];
    }
  }
  
  return null;
};
